'use strict';

// TODO: Remove History, use window.history directly.

const { pubdb } = Function('return this')();
const {
    $, window, document, read_form_data, encodeBooleanSearch, get_nice_publication_type_name, base_href, lang,
    echo_errors, DISPLAY_MARKUPS, display_list, extend, next_tick, ajax_post, path_root, track_view, echo,
    copy_obj, decr_ajax_wait, incr_ajax_wait, foreach_key, login_details, confirm, path_static, parse_qsl, urlencode,
    encode_uri_component,

    search_inplace, search_type, search_is_result,
} = pubdb;
const {
    History, location, JSON, history,
} = window;
const {
    stringify, parse,
} = JSON;


if (history) {
    // remove empty query parts from search string
    const { search } = location;
    if (search) {
        let changed = false;
        const list = parse_qsl(search);
        for (let i = list.length - 1; i >= 0; --i) {
            const [, v] = list[i];
            if (!v) {
                list.splice(i, 1);
                changed = true;
            }
        }
        if (changed) {
            history.replaceState(null, document.title, urlencode(list));
        }
    }
}


function get_search_data () {
    const data = read_form_data({ form: '#pubdb_search_form', values_only: true, visible_only: true });
    read_form_data({ data, form: '#pubdb_search_form .noprint', values_only: true });
    if (data.freetext) {
        data.freetext = encodeBooleanSearch(data.freetext);
    }
    if (data.author) {
        data.author = encodeBooleanSearch(data.author);
    }

    data.count = +data.count;
    data.start = +data.start;

    HIDDEN_TRISTATE_FIELDS.forEach((v) => {
        var datum = data[v];
        if (datum === '-') {
            delete data[v];
        }
    });

    return data;
}

var SEARCH_FIELDS = ['freetext', 'q', 'author', 'a', 'we', 'year_from', 'year_to', 'start', 'count', 'sort'];
var HIDDEN_TRISTATE_FIELDS = ['open_access', 'on_doc_server', 'has_if'];
var HIDDEN_TEXT_FIELDS = ['userpage_id', 'userpage_secret' /*, 'utf8'*/, 'lang'];
[].push.apply(SEARCH_FIELDS, HIDDEN_TRISTATE_FIELDS);
[].push.apply(SEARCH_FIELDS, HIDDEN_TEXT_FIELDS);
for (var i = 0; i < 14; ++i) {
    SEARCH_FIELDS.push('pub_typ[' + i + ']');
}

function query_obj_to_query (query_obj) {
    var query_elements = [];
    for (var i = 0; i < SEARCH_FIELDS.length; ++i) {
        var el = SEARCH_FIELDS[i];
        var eli = query_obj[el];
        if (eli || el === 'start') {
            query_elements.push(el + '=' + encode_uri_component(eli ==/*sic*/ null ? '' : eli));
        }
    }
    return '?' + query_elements.join('&');
}

var wasSeeking = 0;

$(function () {
    var cache = {};
    var prefetching = {};

    var current_search_id = 0;

    $('#pub_typ label').each(function () {
        var self = $(this);
        var text = get_nice_publication_type_name(self.text()).split(/\s*\/\s*/)[0];
        self.text({
            'Elektronische Veröffentlichungen': 'E-Veröffentlichungen',
            'Rundfunk- und Fernsehbeiträge': 'Rundfunk und Fernsehen',
            'Herausgeberschaften von Zeitschriften': 'Zeitschriftenherausgebersch.'
        }[text] || text);
    }).first().addClass('break-after');

    $('#pubdb_search_form :input').keypress(function (ev) {
        if (ev.which === 13) {
            next_tick(function () {
                $('#pubdb_search_form').submit();
            });
            return false;
        }
    });

    var exporting = false;
    function exportRenderer (renderer, img, title) {
        function callback () {
            exporting = renderer;
            $('#pubdb_search_form').submit();
        }

        return $('<img/>', {
            src: img,
            css: {
                padding: '0 0.5ex',
                cursor: 'pointer',
                height: '22px',
                width: '22px'
            },
            alt: title,
            title: title,
            click: function (ev) {
                next_tick(callback);
                return false;
            }
        });
    }

    var MAX_RESULTS_IN_MARKUP = 1000;

    var first_search_result = true;
    var search_result_fired_statechange = false;
    var statechange_fired_search = false;
    var search_results = [];
    var search_result_count = 0;
    function success (data, query_obj, from_cache) {
        function goTo (img, adjective, newPage, setWasSeeking) {
            var valid = newPage >= 0 && newPage < pageCount && newPage !== currentPage;
            var newStart;
            function go () {
                $('#pubdb_search_form :input[name=start]').val(newStart);
                wasSeeking = setWasSeeking;
                doSearch();
            }
            function onclick () {
                if (newPage < 0) {
                    newPage = 0;
                } else if (newPage >= pageCount) {
                    newPage = pageCount - 1;
                }
                newStart = newPage * count;
                if (newStart !== start) {
                    next_tick(go);
                }
            }
            return $('<img/>', {
                src: base_href + '/static/icons/tango/0.8.90/32x32/actions/media-' + img + '.png',
                alt: 'Zur ' + adjective + ' Seite gehen',
                title: 'Zur ' + adjective + ' Seite gehen',
                css: {
                    padding: '0 0.5ex',
                    cursor: 'pointer',
                    visibility: valid ? 'visible' : 'hidden'
                },
                click: valid ? onclick : function () { return false; }
            });
        }

        function seekBar (setWasSeeking) {
            return $('<div/>', {
                'class': 'actions noprint',
                css: { 'text-align': 'center' },
                append: [
                    goTo('skip-backward', 'ersten', 0, setWasSeeking),
                    goTo('seek-backward', 'vorigen', currentPage - 1, setWasSeeking),
                    $('<span/>', {
                        css: { padding: '0 0.5ex' },
                        html: (
                            (lang !== 'en') ? (
                                'Seite <strong style="color:#4c4c4c">' + (currentPage+1) + '</strong> ' +
                                'von <strong style="color:#4c4c4c">' + pageCount + '</strong> ' +
                                'bei <strong style="color:#4c4c4c">' + data.count + '</strong> Suchergebnissen.'
                            ) : (
                                'Page <strong style="color:#4c4c4c">' + (currentPage+1) + '</strong> ' +
                                'of <strong style="color:#4c4c4c">' + pageCount + '</strong> ' +
                                'with <strong style="color:#4c4c4c">' + data.count + '</strong> results.'
                            )
                        )
                    }),
                    goTo('seek-forward', 'nächsten', currentPage + 1, setWasSeeking),
                    goTo('skip-forward', 'letzten', pageCount - 1, setWasSeeking)
                ],
            });
        }

        var dest = $('#pubdb_data');
        if (!data.success) {
            echo_errors(data.errors);
            dest.html($('<strong/>').text('Ein Fehler trat auf. Bitte beachten Sie die Benachrichtigungen.'));
            return;
        }

        search_results = data.data;
        search_result_count = data.count;
        if (search_results.length === 0) {
            dest.html(DISPLAY_MARKUPS.NO_RESULTS_YET);
        } else {
            var action_extras = display_list(search_results, dest, null, data.sort);
            action_extras.scope_cb = function (selected_scope, selected_export) {
                if (selected_scope !== 'all') {
                    return;
                }

                var data = extend(get_search_data(), {
                    start: 0,
                    count: MAX_RESULTS_IN_MARKUP
                });

                function onData (data) {
                    if (!data.success) {
                        next_tick(function () {
                            echo_errors(data.errors);
                        });
                        return null;
                    }
                    return data.data
                }

                function onError (data, err, xhr) {
                    next_tick(function () {
                        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
                    });
                    return null;
                }

                return ajax_post(path_root + '/search/?dont_sort=true', data, onData, onError);
            };

            var start = +$('#pubdb_search_form :input[name=start]').val();
            var count = +$('#pubdb_search_form :input[name=count]').val();
            var currentPage = ~~(start / count);
            var pageCount = ~~((search_result_count + count - 1) / count);

            seekBar().prependTo(dest);
            if (pageCount > 1) {
                seekBar(1).appendTo(dest);
            }

            if (wasSeeking) {
                dest.get(0).scrollIntoView(true);
            }
        }

        if (statechange_fired_search) {
            statechange_fired_search = false;
            return;
        }
        var query = query_obj_to_query(query_obj);
        search_result_fired_statechange = true;
        if (!first_search_result) {
           History.pushState(query_obj, document.title, query);
        } else {
           History.replaceState(query_obj, document.title, query);
           first_search_result = false;
        }

        track_view(base_href + '/pub/search/' + query);
    }

    function error (data, err, xhr) {
        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
    }

    function doSearch () {
        var actions = $('#pubdb_data .actions');
        (actions.length ? actions : $('#pubdb_data')).html('<div class="throbber"></div>').css('display', 'block');

        var data = get_search_data();
        var query = stringify(data);

        var prefetch_data = copy_obj(data);
        prefetch_data.start += prefetch_data.count;
        var prefetch_query = stringify(prefetch_data);

        function prefetch () {
            if (prefetching[prefetch_query] !=/*sic*/ null) {
                return;
            }

            function onSuccess (prefetch_resp) {
                try {
                    cache[prefetch_query] = stringify(prefetch_resp);
                    prefetching[prefetch_query].onSuccess(prefetch_resp, prefetch_data);
                } finally {
                    decr_ajax_wait(prefetching[prefetch_query].waiters);
                    prefetching[prefetch_query] = false;
                }
            }

            function onError (data, err, xhr) {
                try {
                    prefetching[prefetch_query].onError(data, err, xhr);
                } finally {
                    decr_ajax_wait(prefetching[prefetch_query].waiters);
                    prefetching[prefetch_query] = null;
                }
            }

            prefetching[prefetch_query] = {
                onSuccess: function () {},
                onError: function () {},
                waiters: 0
            };
            ajax_post($('#pubdb_search_form').attr('action'), prefetch_data, onSuccess, onError, true);
        }

        (function (search_id) {
            if (typeof cache[query] === 'string') {
                prefetch();
                success(parse(cache[query]), data, false);
            } else if (prefetching[query]) {
                prefetching[query].onSuccess = function (resp, data) {
                    cache[query] = stringify(resp);
                    if (search_id < current_search_id) {
                        return;
                    }
                    success(resp, data, true);
                };
                prefetching[query].onError = error;
                ++prefetching[query].waiters;
                incr_ajax_wait(1);
            } else {
                ajax_post($('#pubdb_search_form').attr('action'), data, function (resp) {
                    cache[query] = stringify(resp);
                    if (search_id < current_search_id) {
                        return;
                    }
                    prefetch();
                    success(resp, data, true);
                }, function (data, err, xhr) {
                    if (search_id < current_search_id) {
                        return;
                    }
                    error(data, err, xhr);
                });
            }
        })(++current_search_id);
    }

    var clicking_label = false;
    $('#pubdb_search_form th:has(label):not(:first)').click(function (ev) {
        if (clicking_label) {
            return true;
        }
        clicking_label = true;
        var label = $('label', this);
        next_tick(function () {
            label.click();
        });
        return false;
    }).find('label').click(function (ev) {
        clicking_label = true;
        next_tick(function () {
            clicking_label = false;
        });
    });

    if (search_inplace && search_type === 'fp') {
        $('#pubdb_search_form select:visible').change(function () {
            $('#pubdb_search_form').submit();
        });
        $('#pubdb_search_form').submit(function () {
            $('#pubdb_search_form [name=search_type]').attr('disabled', true);
        });
    } else if (search_inplace && search_type !== 'fp') {
        $('#pubdb_search_form').submit(function () {
            if (exporting) {
                var self = $(this);
                self.attr({
                    target: '_blank',
                    method: 'POST'
                }).find('[name=renderer]').val(exporting);
                var count_field = $('[name=count]', self);
                var count_val = count_field.val();
                count_field.val('1000');
                next_tick(function () {
                    self.attr({
                        'target': '',
                        'method': 'GET'
                    }).find('[name=renderer]').val('-');
                    count_field.val(count_val);
                });
                exporting = false;
                return;
            }

            next_tick(function () {
                $('#pubdb_search_form [name=start]').val(0);
                doSearch();
            });
            return false;
        });

        History.Adapter.bind(window, 'statechange', function () {
            if (search_result_fired_statechange) {
                search_result_fired_statechange = false;
                return;
            }

            statechange_fired_search = true;
            var data = History.getState().data;
            $('#pubdb_search_form :checkbox').each(function () {
                $(this).prop('checked', false);
            });
            foreach_key(data, function (el) {
                var e = /^(.+)\[\d+\]$/.exec(el);
                if (!e) {
                    $('#pubdb_search_form [name="' + el + '"]').val(data[el]);
                } else {
                    $('#pubdb_search_form [name="' + e[1] + '"][value="' + data[el] + '"]').prop('checked', true);
                }
            });
            next_tick(doSearch);
        });
    }

    $('#use_extended_search').change(function () {
        if ($(this).is(':checked')) {
            $('#extended_search').show();
        } else {
            $('#extended_search').hide();
        }
    }).change();

    $('#search_table tbody:eq(0) [type=radio]').on('change click', function () {
        var self = $(this);
        if (!self.is(':checked')) {
            return;
        }
        var val = self.val();
        if (val !== search_type) {
            location.href = path_root + '/' + ({ fp: 'forschungsprojekt' }[val] || val) + '/search/' + (lang !== 'en' ? '' : '?lang=en');
        }
    });

    var i = $('#search_table tbody:first [type=radio][value="' + search_type + '"]');
    try {
        i.prop('checked', true);
    } catch (e) {
        try {
            i.click().attr('checked', true);
        } catch (e) {
            // void
        }
    }

    if (search_is_result) {
        doSearch();
    }
});

if (login_details && (search_type === 'pub' || search_type === 'pressespiegel')) {
    $(function () {
        function onclick () {
            inner_div.hide();

            var query_obj = get_search_data();
            query_obj.start = 0;
            query_obj.count = 1000;
            delete query_obj.renderer;
            var query = path_root + '/' + search_type + '/search/' + query_obj_to_query(query_obj);

            var on = {
                focus: function () {
                    $(this).select();
                },
                click: function () {
                    $(this).select();
                    return false;
                }
            };
            var content = [
                $('<h3/>').text('URL zum Einbinden in einem IFrame:'),
                $('<input/>', {
                    value: query + '&renderer=iframe',
                    style: 'width: 100%;',
                    readonly: true,
                    on: on
                })
            /*
                ,

                $('<h3/>').text('Auf Mitarbeiterseite im CMS unter dem Reiter „Publikationen“: (als Hauptinhalt eintragen)'),
                $('<textarea/>', {
                    text: '<div>\n' +
                              '<script src="' + query + '&renderer=mitarbeiterseite" type="text/javascript"></script>\n' +
                              'Lädt …\n' +
                          '</div>',
                    rows: 7,
                    style: 'width: 100%;',
                    readonly: true,
                    on: on
                }),

                $('<h3/>').text('Auf beliebiger CMS-Seite:'),
                $('<textarea/>', {
                    text: '<div>\n' +
                              '<script src="' + query + '&renderer=cms" type="text/javascript"></script>\n' +
                              'Lädt …\n' +
                          '</div>',
                    rows: 7,
                    style: 'width: 100%;',
                    readonly: true,
                    on: on
                })
                */
            ];
            confirm('Einbinden der Suchergebnisse', content, [['schließen']], 'html');
        }

        var inner_div = $('<div/>', {
            css: {
                'border': '2px solid #aaa',
                'padding': '0.5ex 1ex',
                'background-color': '#dcdcdc',
                'box-shadow': '2px 2px 3px #aaa',
                'display': 'none'
            },
            append: $('<a/>', {
                href: 'javascript:void(0)',
                append: [
                    'Suchergebnisse',
                    $('<br/>'),
                    'im CMS einbinden'
                ],
                on: {
                    click: function () {
                        next_tick(onclick);
                        return false;
                    }
                }
            })
        });
        $('<div/>', {
            css: {
                'float': 'right',
                'position': 'relative',
                'font-weight': 'normal',
                'white-space': 'nowrap'
            },
            append: [
                $('<a/>', {
                    title: 'Suchergebnisse im CMS einbinden',
                    append: $('<img/>', {
                        src: path_static + '/images/arrow_down_small.png',
                        alt: ''
                    }),
                    on: {
                        click: function () {
                            next_tick(function () {
                                inner_div.toggle(400);
                            });
                            return false;
                        }
                    }
                }),
                $('<div/>', {
                    css: {
                        'position': 'absolute',
                        'right': '-8px',
                        'top': '25px'
                    },
                    append: inner_div
                })
            ],
            insertBefore: $('#search_table tr:eq(0) th label')[0]
        });
    });
}
